import React from 'react';
import { Hours, openState, formatOpenLabel } from '../../branch/hours';
import './branch.css';

interface OpenStatusProps {
  hours?: Hours;
  now: Date;
  lang: 'gr' | 'en';
  className?: string;
}

/** Open-now dot plus its text (the colour never carries the meaning alone). Nothing when hours are unknown. */
const OpenStatus: React.FC<OpenStatusProps> = ({ hours, now, lang, className = '' }) => {
  const state = openState(hours, now);
  if (!state) return null;
  return (
    <span className={`open-status ${state.open ? 'open-status--open' : 'open-status--closed'} ${className}`.trim()}>
      <span className="open-status__dot" aria-hidden="true" />
      {formatOpenLabel(state, lang, now)}
    </span>
  );
};

export default OpenStatus;
